/**
 * @generated SignedSource<<09ae1ed3bde198c1808b4c434c4f9dc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type SessionLimitTypeEnum = "USER" | "ACCOUNT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type contactSessionLimitsRemainingInlineFragment$data = {
  readonly sessionLimits: {
    readonly sessionLimitType: SessionLimitTypeEnum;
    readonly amountRemaining: number;
    readonly expiryDate: any | null;
  } | null;
  readonly " $fragmentType": "contactSessionLimitsRemainingInlineFragment";
};
export type contactSessionLimitsRemainingInlineFragment$key = {
  readonly " $data"?: contactSessionLimitsRemainingInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactSessionLimitsRemainingInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contactSessionLimitsRemainingInlineFragment"
};

(node as any).hash = "06730adbf4b72c11d99d809d2422d22c";

export default node;
